import React from 'react';
// import API from '../../servicios/api';

// import styled from "styled-components";

// import casapropia from '../../assets/casapropia.jpg';
// import mejoravivienda from '../../assets/mejoravivienda.jpg';
// import animPubVivienda from '../../assets/anim_publicidad_funfara.gif';
// Es mejor utilizar la carpeta en el public folder y relacionar asi process.env.PUBLIC_URL + '/assets/anim_publicidad_funfara.gif'

class FinEncuesta extends React.Component {
    // constructor(props) {
    //     super(props);
    // }

    render() { 
        return ( 

            <div className="card">
            <div className="card-header">
                <div className='encuesta-title'>
                    <div><strong>FIN ENCUESTA</strong></div>
                    <div className='fecha-encuesta'>{new Date().toLocaleString()}</div>
                </div>
            </div>
                <div className="card-body">
                    {/* <div className='encuesta-ecase-title'>ENCUESTA CARACTERIZACIÓN SOCIAL Y ECONÓMICA</div> */}
                    <div className='encuesta-ecase-desc'>
                        {/* <p>Proyecto para la <strong>Caracterización Social y Económica</strong> de empleados beneficiarios.</p> */}
                        <p>Se han guardado satisfactoriamente tus datos.</p>
                        <p><strong>Gracias por participar.</strong></p>

                        {/* <p>Comprometidos con el desarrollo integral de nuestros beneficiarios</p> */}
                        <p>Si desea ampliar alguna información, acerquese a la sede de la Fundación o escriba al correo <a href="mailto:trabajosocial@fundacionclubfarallones.org">trabajosocial@fundacionclubfarallones.org</a></p>
                    </div>
                </div>
                
                <div style={{ padding:'10px', textAlign: 'center', height: 'auto', overflow: 'hidden' }}>
                    <hr width='80%' />
                    <p>Proyectos actuales en los que podría participar en este 2022</p>
                    {/* <img className='img-publicidad' src={animPubVivienda} alt="publicidad..." /> */}
                    {/* <img className='img-publicidad' src={'../'+process.env.PUBLIC_URL + '/assets/anim_publicidad_funfara.gif'} alt="publicidad..." /> */}
                    <img className='img-publicidad' src='/encuestas/encuesta1/assets/anim_publicidad_funfara.gif' alt="publicidad..." />
                </div>
            </div>
           
         );
    }
}
 
export default FinEncuesta;